import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {AchievementFilters} from "../../services/ngage/achievements";

export default function useGetAchievements(
  criteria: AchievementFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['achievements.all', criteria],
    () => ngage.achievements.filtered(criteria),
    {enabled, keepPreviousData}
  );
}